// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from lock.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function LockIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 0a5 5 0 0 1 4.995 4.783L13 5v2h2a1 1 0 0 1 .993.883L16 8v7a1 1 0 0 1-.883.993L15 16H1a1 1 0 0 1-.993-.883L0 15V8a1 1 0 0 1 .883-.993L1 7h2V5a5 5 0 0 1 5-5Zm6 9H2v5h12V9ZM8 2a3 3 0 0 0-2.995 2.824L5 5v2h6V5a3 3 0 0 0-3-3Z"
      />
    </svg>
  );
}
